import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { LoaderMessage } from "../../../../components/loaderMessage/loaderMessage";
import DocumentsModal from "../../../../components/modals/documentsModal/documentsModal";
import NarLetterModal from "../../../../components/modals/narLetterModal/narLetterModal";
import { ModalId } from "../../../../enums/modalId";
import { closeModal } from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";

const TreatmentPlan = () => {
  const { singleMedicalPaOrder, isLoading } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [medicineNames, setMedicineNames] = useState<string[]>([]);
  const [documents, setDocuments] = useState<File[]>([]);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (isModalOpen) {
      openModal(ModalId.NAR_LETTER_MODAL);
      // openModal("documents-modal");
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (singleMedicalPaOrder?.auth_on_file) {
      const authOnFile = singleMedicalPaOrder.auth_on_file as any;
      const medicines = authOnFile.medicine_names_from_treatment_plan || [];
      setMedicineNames(medicines);
    }
  }, [singleMedicalPaOrder]);

  return (
    <div className="treatment-plan-container flex h-full flex-col">
      {isLoading ? (
        <LoaderMessage message={"Fetching Treatment Plan"} />
      ) : (
        <div className="h-full p-4">
          <h3 className="mb-4 text-lg font-semibold">Medicine Names</h3>
          <div className="mb-4 flex flex-col gap-2"></div>
          {medicineNames.length > 0 ? (
            <div className="rounded-lg border bg-white p-4 shadow-sm">
              <div className="max-h-96 overflow-y-auto">
                <ul className="space-y-2">
                  {medicineNames.map((medicine, index) => (
                    <li
                      key={index}
                      className="rounded-md border-l-4 border-blue-500 bg-gray-50 p-3"
                    >
                      <span className="font-medium text-gray-800">
                        {medicine}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ) : (
            <div className="flex h-64 items-center justify-center rounded-lg bg-gray-50">
              <p className="text-center text-gray-500">
                No medicine names found in treatment plan
              </p>
            </div>
          )}
        </div>
      )}

      <NarLetterModal
        onClose={() => {
          setIsModalOpen(false);
          dispatch(closeModal());
        }}
        showDragDropUpload={true}
      />
      <DocumentsModal
        onClose={() => {
          setIsModalOpen(false);
          dispatch(closeModal());
        }}
        documentsName={documents.map((document) => document.name)}
        documentsList={documents}
        id={singleMedicalPaOrder?.id ?? ""}
        newDocumentNames={(urls) => console.log(urls)}
        newFiles={(files) => setDocuments(files)}
      />
    </div>
  );
};

export default TreatmentPlan;
